module.exports = __webpack_public_path__ + "media/images/pages/non-gcse/richard-3df54e309129e701c1102c52315f6aaa.png";